import createUserConfigurationOperation from 'owa-service/lib/operation/createUserConfigurationOperation';
import createUserConfigurationRequest from 'owa-service/lib/factory/createUserConfigurationRequest';
import serviceUserConfiguration from 'owa-service/lib/factory/serviceUserConfiguration';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import getMailboxExportUserConfigurationName from './getMailboxExportUserConfigurationName';

export default async function createMailboxExportRequest() {
    let response = await createUserConfigurationOperation({
        Header: getJsonRequestHeader(),
        Body: createUserConfigurationRequest({
            UserConfiguration: serviceUserConfiguration({
                UserConfigurationName: getMailboxExportUserConfigurationName(),
            }),
        }),
    });

    return response.Body.ResponseMessages.Items[0] as SingleResponseMessage;
}
